import BaseModel from './BaseModel';

/**
 * Model for Affiliate Dashboard Statistics
 * Handles aggregate statistics for implementation status dashboard
 */
class AffiliateDashboardStatsModel extends BaseModel {
  init(data) {
    this.count = data.count || 0;
    this.loginsLastSevenDays = data.login_last_seven_days_count || 0;
    this.activeAffiliateCompaniesCount = data.active_affiliate_companies_count || 0;
    this.newGoLiveCount = data.new_go_live_count || 0;
    this.openOpportunitiesCount = data.open_opportunities_count || 0;
    this.lastUpdatedDate = data.last_etl_update || '';

    // Aggregate training sub-stages into a single "inTraining" count
    const inTrainingCount = (data.stage_counts?.in_training || 0)
                            + (data.stage_counts?.in_training_1 || 0)
                            + (data.stage_counts?.in_training_2 || 0)
                            + (data.stage_counts?.in_training_3 || 0)
                            + (data.stage_counts?.in_training_4 || 0);

    // Aggregate lost, unqualified, and demo_rejected into a single "lost" count
    const lostCount = (data.stage_counts?.lost || 0)
                      + (data.stage_counts?.unqualified || 0)
                      + (data.stage_counts?.demo_rejected || 0);

    this.stageCounts = {
      initialContact: data.stage_counts?.initial_contact || 0,
      demoing: data.stage_counts?.demoing || 0,
      deciding: data.stage_counts?.deciding || 0,
      inTraining: inTrainingCount,
      live: data.stage_counts?.live || 0,
      lost: lostCount,
    };
  }
}

export default AffiliateDashboardStatsModel;
